import {
  LayoutDashboard, Users, FileText, ClipboardList, Factory,
  Package, Wallet, BookOpen, UserCog, BarChart3, Settings, Mail,
  type LucideIcon,
} from 'lucide-react';
import type { Module } from '@/types';

export type NavItem = {
  module: Module;
  label: string;
  path: string;
  icon: LucideIcon;
  section: 'operate' | 'finance' | 'grow' | 'admin';
};

export const NAV_ITEMS: NavItem[] = [
  // Operate
  { module: 'dashboard',  label: 'Dashboard',  path: '/',           icon: LayoutDashboard, section: 'operate' },
  { module: 'clients',    label: 'Clients',    path: '/clients',    icon: Users,           section: 'operate' },
  { module: 'quotes',     label: 'Quotes',     path: '/quotes',     icon: FileText,        section: 'operate' },
  { module: 'orders',     label: 'Orders',     path: '/orders',     icon: ClipboardList,   section: 'operate' },
  { module: 'production', label: 'Production', path: '/production', icon: Factory,         section: 'operate' },
  { module: 'inventory',  label: 'Inventory',  path: '/inventory',  icon: Package,         section: 'operate' },

  // Finance
  { module: 'financials', label: 'Financials', path: '/financials', icon: Wallet,          section: 'finance' },
  { module: 'accounting', label: 'Accounting', path: '/accounting', icon: BookOpen,        section: 'finance' },
  { module: 'reports',    label: 'Reports',    path: '/reports',    icon: BarChart3,       section: 'finance' },

  // Grow
  { module: 'newsletter', label: 'Newsletter', path: '/newsletter', icon: Mail,            section: 'grow' },

  // Admin
  { module: 'hr',         label: 'People',     path: '/hr',         icon: UserCog,         section: 'admin' },
  { module: 'settings',   label: 'Settings',   path: '/settings',   icon: Settings,        section: 'admin' },
];

export const SECTION_LABELS: Record<NavItem['section'], string> = {
  operate: 'Operate',
  finance: 'Finance',
  grow:    'Grow',
  admin:   'Administration',
};
